export default "__VITE_ASSET__CKqu9PBg__"